<template>
  <div>
    <div class="title">
      操作日志
    </div>
    <div class="body">
      <div class="bodyTitle">
        <el-form :model="searchForm" size="small" label-width="0">
          <el-form-item>
            <el-col :span="4">
              <el-select v-model="searchForm.userId" style="width: 90%" @change="userChange">
                <el-option v-for="item in userList" :key="item.id" :value="item.id" :label="item.nickname" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-date-picker
                v-model="value1"
                size="small"
                type="datetimerange"
                style="width: 90%"
                range-separator="至"
                @change="timeChange"
                value-format="yyyy-MM-dd HH:mm:ss"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-col>
            <el-col :span="10">
              <el-select v-model="searchForm.type" style="width: 35%" @change="typeChange" placeholder="分类">
                <el-option v-for="(type,index) in typeList" :key="type" :label="type" :value="index" />
              </el-select>
            </el-col>
            <el-col :span="4">
              <el-input placeholder="请输入内容" v-model="input3" class="input-with-select" size="small">
                <el-button size="small" slot="append" icon="el-icon-search" @click="searchBtn"></el-button>
              </el-input>
            </el-col>
          </el-form-item>
        </el-form>
      </div>

      <div class="bodyTable">
        <el-table :data="tableData" style="width: 100%"
        :header-cell-style="{background: 'rgb(250,250,250)', color: 'black', fontWeight: '400'}">
          <el-table-column
            prop="useraccount"
            label="账号">
          </el-table-column>
          <el-table-column
            prop="username"
            label="姓名">
          </el-table-column>
          <el-table-column
            prop="content"
            label="操作">
          </el-table-column>
          <el-table-column
            label="分类">
            <template slot-scope="{ row }">
              {{ typeList[Number(row.firstType)] }}
            </template>
          </el-table-column>
          <el-table-column
            prop="addr"
            label="IP">
          </el-table-column>
          <el-table-column
            prop="gmtCreate"
            label="时间">
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="pageBox">
          <Page :total="total" @on-change="pageChange" :current="curPage" show-total show-elevator />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getoperationLogList } from "@/api/companyManager"
import { getAlluser } from '@/api/processManager'
export default {
  name: 'operationLog',
  data() {
    return {
      value1: [],
      input3: '',
      tableData: [],
      total: 0,
      curPage: 1,
      typeList: ['重大危险源', '可燃有毒气体', '风险分区管理', '全流程安全生产',
        '人员在岗在位', '应急监控中心', 'LED配置', '企业管理', '其他'
      ],
      userList: [],
      searchForm: {
        keywords: '',
        type: '',
        userId: '',
        startTime: '',
        endTime: ''
      }
    }
  },
  created() {
    getAlluser().then(res => {
      this.userList = res.body.data
    })
    this.getList()
  },
  methods:{
    getList() {
      getoperationLogList({limit: 10, curPage: this.curPage, ...this.searchForm}).then(res => {
        // console.log(res)
        this.tableData = res.body.data
        this.total = res.body.cum
      })
    },
    pageChange(val){
      this.curPage = val
      this.getList()
    },
    userChange(val) {
      this.searchForm.userId = val
      this.getList()
    },
    timeChange(val) {
      if(val) {
        this.searchForm.startTime = val[0]
        this.searchForm.endTime = val[1]
      } else {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }
      this.getList()
    },
    typeChange(val) {
      this.searchForm.type = val
      this.getList()
    },
    // 搜索
    searchBtn() {
      this.getList()
    }
  },
}
</script>

<style scoped>
.title {
  height: 60px;
  width: 100%;
  line-height: 60px;
  background: white;
  padding-left: 25px;
  margin-bottom: 15px
}
.body {
  width: 99%;
  /* height: 300px; */
  background: white;
  margin: auto;
  padding: 15px;
}
.bodyTitle /deep/ .el-range-editor.el-input__inner{
  padding: 2px 10px 0px 10px
}
.bodyTitle /deep/ .el-range-editor--small .el-range-separator {
  line-height: 30px
}
.bodyTable {
  margin-top: 20px
}
.pageBox {
  text-align: right;
  margin-top: 15px;
}
</style>